import React from 'react';

interface ImagePlaceholderProps {
  label: string;
  className?: string;
  style?: React.CSSProperties;
}

const ImagePlaceholder: React.FC<ImagePlaceholderProps> = ({ label, className, style }) => (
  <div
    className={`flex items-center justify-center bg-gray-800 text-gray-500 rounded-2xl w-full h-full ${className}`}
    style={style}
  >
    <span className="text-sm tracking-widest uppercase">{label}</span>
  </div>
);

export default ImagePlaceholder;

